import React, {FC} from 'react';
import {useStoreon} from 'storeon/react';
import {GxForm, GxButton, GxIcon, GxCheckbox} from '@garpix/garpix-web-components-react';
import {useFormik} from 'formik';
import { State } from '@/interfaces';
import ModalLayout from '../../../../components/ModalLayout';
import styles from './styles/index.module.scss';
import {IModalTransferCertificate} from './interfaces';
import {CertificateIcon} from '../../../../assets';
import {checkEmailUser} from '../../../Certificates/helpers';

const ModalTransferCertificate: FC<IModalTransferCertificate> = ({user, flag, type, onRequestClose, onSave}) => {
    const {certificates} = useStoreon<State>('certificates');
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            print_qr_label: false,
            send_email: false,
            print_pdf: false
        },
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: ({print_pdf, send_email, print_qr_label}) => {
            onSave({print_pdf, send_email, print_qr_label});
            onRequestClose();
            formik.resetForm();
        }
    });

    return (
        <ModalLayout
            flag={flag}
            onClose={() => {
                onRequestClose();
                formik.setValues({
                    print_qr_label: false,
                    send_email: false,
                    print_pdf: false
                });
            }}
        >
            <div className={styles['header']}>
                <div className={styles['header--container']}>
                    <GxIcon className={styles['header--icon']} src={CertificateIcon}/>
                    <h2 className={styles['header--title']}>Передача сертификата</h2>
                </div>
                {user && <span>Кому: {user.first_name} {user.last_name}</span>}
            </div>
            <GxForm onGx-submit={formik.submitForm}>
                <div className={styles['main']}>
                    <GxCheckbox
                        name="send_email"
                        checked={formik.values.send_email}
                        className={styles['main-item']}
                        onGx-change={(e: any) => {
                            formik.setFieldValue('send_email', e.target.checked);
                        }}
                        disabled={type === 'sale' ? (user ? !user.email : false) : !checkEmailUser(certificates.results)}
                    >
                        {type === 'print' && <> {`Отправить на email ${!checkEmailUser(certificates.results) ? '(у некоторых контрагентов отсутствует E-mail)' : ''}`}</>}
                        {type === 'sale' && <>{`Отправить на email ${(user && !user.email) ? '(у контрагента отсутствует E-mail)' : ''}`} </>}
                    </GxCheckbox>
                    <GxCheckbox
                        name="print_qr_label"
                        className={styles['main-item']}
                        checked={formik.values.print_qr_label}
                        onGx-change={(e: any) => {
                            formik.setFieldValue('print_qr_label', e.target.checked);
                        }}
                    >
                        Распечатать этикетку с QR-кодом
                    </GxCheckbox>
                    <GxCheckbox
                        name="print_pdf"
                        className={styles['main-item']}
                        checked={formik.values.print_pdf}
                        onGx-change={(e: any) => {
                            formik.setFieldValue('print_pdf', e.target.checked);
                        }}
                    >
                        Распечатать PDF файл с QR-кодом
                    </GxCheckbox>
                </div>
                <div className={styles['footer']}>
                    <div className={styles['footer--container']}>
                        <GxButton className={styles['btn--close']} onClick={onRequestClose}>Отмена</GxButton>
                        <GxButton className={styles['btn--save']}
                                  disabled={type === 'print' ? (!formik.values.print_pdf && !formik.values.print_qr_label && !formik.values.send_email) : false}
                                  type="submit">Подтвердить</GxButton>
                    </div>
                </div>
            </GxForm>

        </ModalLayout>
    );
};

export default ModalTransferCertificate;